import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { AccreditationSegment } from 'src/app/common/common-product/models/product-short.model';
import { Contract } from 'src/app/snatch/models/contract.model';
import { EnvironmentService } from 'src/app/snatch/services';
import { Router } from '@angular/router';

@Component({
  selector: 'leap-segment-information',
  templateUrl: './segment-information.component.html',
  styleUrls: ['./segment-information.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SegmentInformationComponent implements OnInit {

  @Input() segment: AccreditationSegment;
  @Input() segmentsMapper: Map<string, Contract>;

  @Output() getAccess: EventEmitter<string> = new EventEmitter();
  
  constructor(private environment: EnvironmentService, private router: Router) { }

  ngOnInit() {
  }

  getAccessFn() {
    this.getAccess.emit(this.segment.code);
  }

  goToContract(contractId: string) {
    const url = `${this.environment.saharaUrl}/contracts/buyer/${contractId}/details-signed`;
    window.open(url, "_blank", "noopener,noreferrer");
  }

  goToOrder(contract: Contract) {
    if (contract.contractDetails && contract.contractDetails.order && contract.contractDetails.order.salesOrderId)
      this.router.navigate(['orders', 'details', contract.contractDetails.order.salesOrderId])
  }
}
